import script from "./OperatorTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorTag.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorTag.vue?vue&type=style&index=0&id=77e7379a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e7379a"]])

export default __exports__